import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";
import {
  faPencilAlt,
  faTrash,
  faFlag,
} from "@fortawesome/free-solid-svg-icons";
import { ReactComponent as EventDriven } from "../../../Images/general_icons/eventdriven.svg";
import { ReactComponent as SyncIcon } from "../../../Images/general_icons/Navigation_Menu.svg";
import { ReactComponent as PrimaryIcon } from "../../../Images/general_icons/primary.svg";
import Tooltip from "antd/lib/tooltip";
import IntegrationSyncBadge from "./IntegrationSyncBadge";
import NotificationHeartbeatButton from "./notificationHeartbeat/notificationHeartbeatButton";

import "./singleIntegrationItem.scss";

const SingleIntegrationItem = ({
  typeData,
  data = {},
  category,
  handleEdit,
  handleDelete,
  handleStatus,
  setSelectedSlackApp,
  setShowSlackChannelsPopup,
  testNotificationLoading,
  setTestNotificationLoading,
}) => {
  const isViewer = useSelector((state) => state.profilesReducer.isViewer);

  // spesific types preferences
  const showAccount = ["aws", "gcp", 'azurerm'];
  const allowedFeaching = ["aws", "gcp",'azurerm'];
  const categoriesWithSyncStatus = ["cloud", "vcs", "notification"];

  return (
    <div className="SingleIntegrationItem">
      <div className="SingleIntegrationItem__labels row">
        {categoriesWithSyncStatus.includes(category) ? (
          <IntegrationSyncBadge
            data={data}
            type={typeData?.sever_name}
            category={category}
          />
        ) : (
          <span />
        )}
        <img
          src={typeData?.icon}
          alt={typeData?.icon}
          className={`SingleIntegrationItem__labels-${typeData?.server_name}`}
        />
      </div>

      <div className="SingleIntegrationItem__content col center">
        <span className="SingleIntegrationItem__content-name centered bold">
          {data?.name || "Choose a name"}
        </span>
        {showAccount.includes(typeData?.server_name) && (
          <span className="SingleIntegrationItem__content-account centered">
            {data?.accountNumber}
          </span>
        )}
      </div>

      <div className="SingleIntegrationItem__actions">
        <div className="SingleIntegrationItem__actions-flags row">
          {data?.isProd && (
            <Tooltip title="Production Account">
              <FontAwesomeIcon
                icon={faFlag}
                className="SingleIntegrationItem__actions-flags-prod"
              />
            </Tooltip>
          )}
          {data?.isEventDriven && (
            <Tooltip title="Event-Driven Enabled">
              <EventDriven className="SingleIntegrationItem__actions-flags-event" />
            </Tooltip>
          )}
          {category === 'notification' && !isViewer && 
            <NotificationHeartbeatButton 
              item={data} 
              setSelectedSlackApp={setSelectedSlackApp}
              setShowSlackChannelsPopup={setShowSlackChannelsPopup}
              testNotificationLoading={testNotificationLoading}
              setTestNotificationLoading={setTestNotificationLoading}
            />}
        </div>
        {data?.isProd || data?.isEventDriven || data?.isPrimary ? (
          <span className="SingleIntegrationItem__actions-line" />
        ) : null}
        <div className="SingleIntegrationItem__actions-btns row">
          <button onClick={handleEdit} disabled={isViewer}>
            <FontAwesomeIcon icon={faPencilAlt} />
          </button>
          <button onClick={handleDelete} disabled={isViewer}>
            <FontAwesomeIcon icon={faTrash} />
          </button>
          {allowedFeaching.includes(typeData?.server_name) && (
            <button onClick={handleStatus}>
                <SyncIcon className="SingleIntegrationItem__actions-flags-primary" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SingleIntegrationItem;
